import React from 'react';

import { useNavigate } from 'react-router-dom';

import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import PropTypes from 'prop-types';

import { COLORS } from '../../Constant/COLORS';

const PageError = ({
  title = 'Something went wrong',
  message = "We couldn't load this page. Please try again or go back home.",
  onRetry,
  retryLabel = 'Try again',
  homeHref = '/',
}) => {
  const navigate = useNavigate();

  return (
    <Box
      minHeight='100vh'
      display='flex'
      alignItems='center'
      justifyContent='center'
      bgcolor='#f6f8fb'
      px={2}
      py={4}
    >
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: 520,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          p: { xs: 3, sm: 5 },
          textAlign: 'center',
        }}
      >
        <Stack alignItems='center' gap={2}>
          <Box
            sx={{
              width: 88,
              height: 88,
              borderRadius: '50%',
              backgroundColor: '#fdecea',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <ErrorOutlineIcon sx={{ fontSize: 52, color: '#c0392b' }} />
          </Box>

          <Typography variant='h5' fontWeight={700}>
            {title}
          </Typography>

          <Typography color='text.secondary'>{message}</Typography>

          <Stack direction={{ xs: 'column', sm: 'row' }} gap={1.5} mt={2}>
            {onRetry && (
              <Button
                variant='contained'
                onClick={onRetry}
                sx={{ color: '#fff', backgroundColor: COLORS.blue }}
              >
                {retryLabel}
              </Button>
            )}
            <Button
              variant='outlined'
              onClick={() => navigate(homeHref)}
              sx={{ color: COLORS.blue, borderColor: COLORS.blue }}
            >
              Back to home
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
};

PageError.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  onRetry: PropTypes.func,
  retryLabel: PropTypes.string,
  homeHref: PropTypes.string,
};

export default PageError;
